module.exports = __webpack_public_path__ + "img/404-cloud.0f4bc32b.png";